"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(_ref) {
  var hasFooter = _ref.hasFooter;
  return {
    borderRadius: 'md',
    borderBottomRadius: {
      base: '0',
      tablet: 'md'
    },
    background: 'white',
    color: 'inherit',
    marginY: 0,
    zIndex: 'layer8',
    boxShadow: 'lg',
    paddingBottom: hasFooter ? 0 : 4
  };
};